<div class="fs-12px">
  {{ "last_comment" | localize }}
  {{ latestDate | date : "MMMM dd, yyyy, HH:mm" | timeAgo : 24 }}
</div>
